import {NotificationDto, NotificationEventType} from "@/api/dto/notification";
import React from "react";

import CrisisIcon from "@/assets/icons/Custom-Icon-Crisis.svg?react";
import ReferralIcon from "@/assets/icons/Custom-Icon-Referral.svg?react";
import JusticeInvolvedIcon from "@/assets/icons/Custom-Icon-JI.svg?react";
import AvatarDetails from "@common/AvatarDetails";
import Icon, {ICONS} from "patient-ping-remedy/packages/icon";
import {colors} from "patient-ping-remedy/packages/theme";

type NotificationIconInfoType = { [K in NotificationEventType]: (notification?: NotificationDto) => React.ReactElement };

export const NotificationIcons: NotificationIconInfoType = {
  CRISIS: () => <CrisisIcon />,
  REFERRAL: () => <ReferralIcon />,
  HOSPITAL: () =>  <Icon iconClass={ICONS.hospital} style={{height: 18, width: 18}} color={colors.white} />,
  JI: () => <JusticeInvolvedIcon style={{height: 20, width: 20}} />,
  FIND_HELP: () => <ReferralIcon />,
  POST_ACUTE_CARE: () => <Icon iconClass={ICONS["clinic-medical"]} style={{height: 18, width: 18}} color={colors.white} />,
  MESSAGE_MENTION: (notification) => <AvatarDetails user={notification?.message?.user} roster={notification?.client.roster} />,
  TASKS: () => <Icon iconClass={ICONS.tasks} style={{height: 18, width: 18}} color={colors.white} />,
  CRISIS_SERVICES: () => <Icon iconClass={ICONS["hand-holding-medical"]} style={{height: 18, width: 18}} color={colors.white} />,
  PROMISE_SERVICES: () => <Icon iconClass={ICONS["clinic-medical"]} style={{height: 18, width: 18}} color={colors.white} />,
  BED_AVAILABILITY: () => <Icon iconClass={ICONS.bed} style={{height: 18, width: 18}} color={colors.white} />,
  ADDITIONAL_EVENT: () => <Icon iconClass={ICONS.house} style={{height: 18, width: 18}} color={colors.white} />
};
